import { render } from "./AboutPageImg.vue?vue&type=template&id=b44f70d6&scoped=true"
const script = {}

import "./AboutPageImg.vue?vue&type=style&index=0&id=b44f70d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b44f70d6"]])

export default __exports__